"use client";
import React, { createContext, useEffect, useState } from "react";
import { ComponentProps } from "react";
import { Builder, BuilderComponent, useIsPreviewing, builder } from "@builder.io/react";
import { notFound } from "next/navigation";
import "../builder-registry";

type BuilderPageProps = ComponentProps<typeof BuilderComponent>;

// Builder Public API Key set in .env file
builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

type PageData = Record<string, unknown>;
export const PageContext = createContext<PageData>({});

export function RenderBuilderContent({ content, model, data }: BuilderPageProps) {
  // Call the useIsPreviewing hook to determine if
  // the page is being previewed in Builder
  const isPreviewing = useIsPreviewing();
  
  // Check Builder.isEditing/isPreviewing only on client to avoid hydration mismatch
  const [isInBuilderMode, setIsInBuilderMode] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);
    // Only check Builder static properties on client side
    setIsInBuilderMode(Builder.isEditing || Builder.isPreviewing || isPreviewing);
  }, [isPreviewing]);
  
  // Only show 404 if we're not in Builder mode AND there's no content
  // Wait for client-side mount to avoid false 404s during hydration
  if (isMounted && !content && !isInBuilderMode) {
    notFound();
  }

  // If "content" has a value or the page is being previewed in Builder,
  // render the BuilderComponent with the specified content and model props.
  return (
    <PageContext.Provider value={{ data, isPreviewing }}>
      <BuilderComponent 
        content={content} 
        model={model} 
      />
    </PageContext.Provider>
  );
}

// export function RenderBuilderContentPreview({ content, model, data }: BuilderPageProps) {
//   // Call the useIsPreviewing hook to determine if
//   // the page is being previewed in Builder
//   const isPreviewing = useIsPreviewing();
//   // If "content" has a value or the page is being previewed in Builder,
//   // render the BuilderComponent with the specified content and model props.
//   if (content && isPreviewing) {
//     return (
//       <PageContext.Provider value={{ data }}>
//         <BuilderComponent content={content} model={model} />
//       </PageContext.Provider>
//     );
//   }
//   // If the "content" is falsy and the page is
//   // not being previewed in Builder, render the
//   // DefaultErrorPage with a 404.
//   return <DefaultErrorPage statusCode={404} />;
// }
